import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RealEstateDeveloper } from '../../models/real-estate-developer.model';
import { Paginable } from '../../utils/pagination.utils';
import { changeDataIsoStringToDate } from '../../utils/parse.utils';
import { RealEstateDevelopersPaginableParams, RealEstateDevelopersService } from './real-estate-developers.service';

@Injectable()
export class RealEstateDevelopersServiceApi implements RealEstateDevelopersService {
  constructor(
    private http: HttpClient,
  ) {}

  async get(id: number): Promise<RealEstateDeveloper | null> {
    const { data } = await firstValueFrom(this.http.get<{ data: RealEstateDeveloper | null; }>(`${environment.apiUrl2}/real-estate-developers/${id}`));
    return changeDataIsoStringToDate(data);
  }

  async getAll(params: RealEstateDevelopersPaginableParams): Promise<Paginable<RealEstateDeveloper>> {
    const { limit, page, tags } = params;
    const queryParams = new URLSearchParams({
      limit: `${limit}`,
      page: `${page}`,
      ...(tags && { tags: tags.join(',') }),
    });
    const { data } = await firstValueFrom(this.http.get<{ data: Paginable<RealEstateDeveloper>; }>(`${environment.apiUrl2}/real-estate-developers?${queryParams.toString()}`));
    data.data = data.data.map(changeDataIsoStringToDate);
    return data;
  }
}
